export default __webpack_public_path__ + "ef40a9663cb3acb4ef4d90e230de6638.jpg";